export default __webpack_public_path__ + "static/media/heart.37d159c9.svg";